export default "__VITE_ASSET__j_BpEKfi__"